<ng-container>
    <span>{{"changeSummaryType" | translate}}</span>
    <mat-dialog-content>
        <app-summary-selector [initialState]="data" (type)="close($event)"></app-summary-selector>
    </mat-dialog-content>
</ng-container>